import { Text, View, Image } from "@react-pdf/renderer";
import amlReportStyles from "../Styles/amlReportStyles";
import HeaderLogo from "../../../../../assets/icons/aml/check2-white.png";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";

const Header = () => {
  return (
    <View style={amlReportStyles.header} fixed>
      <Image src={HeaderLogo} style={{ width: 90, height: 30 }} />
      <Text
        style={{ ...amlReportStyles.amlTextCaption, color: theme.colors.White }}
        render={({ pageNumber, totalPages }) => `${pageNumber}`}
        fixed
      />
    </View>
  );
};

export default Header;
